import React from 'react'

import { boxList } from '../../../module/boxes'
import TickIcon from '../icon/Tick'
import {
  AssessmentBarContainer,
  AssessmentButton,
  AssessmentIcon,
  AssessmentDescription,
} from './AssessmentBar-styled'

export default ({ selectedBoxId, onSelect }) => {
  return (
    <AssessmentBarContainer>
      {boxList.map(box => {
        const { id, response } = box
        const selectBox = () => {
          onSelect({ boxId: id })
        }
        const isSelected = !!(selectedBoxId === id)
        const boxWidthPercent = 100 / boxList.length
        return (
          <AssessmentButton key={id} onClick={selectBox} boxWidthPercent={boxWidthPercent}>
            <AssessmentIcon boxId={id}>
              {isSelected && <TickIcon fill="white" width="20" />}
            </AssessmentIcon>
            <AssessmentDescription>{response}</AssessmentDescription>
          </AssessmentButton>
        )
      })}
    </AssessmentBarContainer>
  )
}



// WEBPACK FOOTER //
// ./src/component/_presentational/AssessmentBar/AssessmentBar.jsx